import { ReactComponent as DeleteIcon } from "../../../assets/icons/delete-icon-new.svg";
import { ReactComponent as PlusIcon } from "../../../assets/icons/Plus.svg";
import UBAlertModal from "../../../Libraries/UBAlertModal";
import LineText from "../../../Libraries/LineText";
import UBButton from "../../../Libraries/UBButton";
import { AppColorInput } from "../../../Libraries";
import React, { useRef, useState } from "react";
import VariantInput from "./VariantInput";
import "./styles.css";
import {
  VariantTextPlaceholders,
  ATTR_OPTION_ACTIONS,
  checkDraginLimit,
  filterColorArray,
} from "../../../constants/variantConstants";
import { Box } from "@mui/material";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import ConfirmationModal from "../Modals/ConfirmationModal";

const VariantColorComponent = ({
  keyId = "Color",
  attributes = [],
  isFromEditFlow,
  handleSave,
  closeEdit,
  stock,
}) => {
  const [currentInputs, setCurrentInputs] = useState(
    attributes?.length
      ? [...attributes, { label: "", value: "" }]
      : [{ label: "", value: "" }]
  );
  const [showDiscard, setShowDiscard] = useState(false);
  const [showColorError, setShowColorError] = useState(false);
  const dragOverRef = useRef(null);
  const dragStartRef = useRef([]);

  const handleSwap = () => {
    if (
      dragOverRef.current == null ||
      dragStartRef.current == null ||
      dragOverRef.current === dragStartRef.current ||
      dragOverRef.current + 1 === currentInputs.length
    ) {
      dragOverRef.current = null;
      dragStartRef.current = null;
      return;
    } else {
      let tempClone = [...currentInputs];
      [tempClone[dragOverRef.current], tempClone[dragStartRef.current]] = [
        tempClone[dragStartRef.current],
        tempClone[dragOverRef.current],
      ];
      setCurrentInputs(tempClone);
      dragOverRef.current = null;
      dragStartRef.current = null;
    }
  };

  const handleCancel = (st) => {
    setShowDiscard(false);
  };

  const handleSaveDiscard = (st) => {
    if (stock && stock?.variants?.length) {
      setShowDiscard(false);
      closeEdit && closeEdit();
      return;
    }
    setCurrentInputs([{ label: "", value: "" }]);
    handleSave && handleSave("", []);
    setShowDiscard(false);
  };

  const handleColorInputChange = (action, val, ind) => {
    const curr = [...currentInputs];
    if (val === "" && currentInputs.length >= 2 && curr[ind].label === "") {
      curr.splice(ind, 1);
      setCurrentInputs(curr);
      return;
    }
    if (action === ATTR_OPTION_ACTIONS.INPUT) {
      curr[ind].value = val;
      if (ind + 1 === currentInputs.length) {
        curr.push({ label: "", value: "" });
      }
      setCurrentInputs(curr);
    } else if (action === ATTR_OPTION_ACTIONS.DELETE) {
      if (1 !== currentInputs.length) {
        curr.splice(ind, 1);
        setCurrentInputs(curr);
      }
    } else {
      return;
    }
  };

  const handleDragEnd = (e) => {
    const isInLimit = checkDraginLimit(
      e?.clientX,
      e?.clientY,
      `color-${keyId}-attr-options`
    );
    if (isInLimit) {
      handleSwap();
    }
  };

  const handleSaveClrBtn = () => {
    // if (
    //   validateColorArray(currentInputs) &&
    //   filterColorArray(currentInputs).length
    // ) {
    const cloneInps = [...currentInputs];
    triggerLogEvent(analytics, "sb_variant_color", { attribute_key: keyId, color_count: filterColorArray(cloneInps).length });
    handleSave && handleSave(keyId, filterColorArray(cloneInps));
    // } else {
    //   setShowColorError(true);
    //   toast.error("Name and Color are required fields", {
    //     className: "errorToast",
    //     toastId: "err_clr_required",
    //   });
    // }
  };

  React.useEffect(() => {
    setShowColorError(false);
  }, [currentInputs]);

  return (
    <div className='mt-1'>
      <LineText>Attribute options</LineText>
      <div id={`color-${keyId}-attr-options`}>
        {currentInputs.map((inpVal, ind) => {
          return (
            <div
              key={ind}
              className="d-flex align-items-center gap-1 my-3 user-select-none"
              draggable={!Boolean(currentInputs.length - 1 === ind)}
              onDragStart={(e) => {
                dragStartRef.current = ind;
              }}
              onDragOver={(e) => {
                e.stopPropagation();
                e.preventDefault();
              }}
              onDragEnter={(e) => {
                dragOverRef.current = ind;
              }}
              onDragEnd={handleDragEnd}
            >
              <div className="colorNameInput">
                <VariantInput
                  value={inpVal?.value}
                  handleChange={(action, val) => {
                    if (val.length && val.trim() === '') return;
                    handleColorInputChange(action, val, ind);
                  }}
                  placeholder={VariantTextPlaceholders[keyId]}
                  showDelete={false}
                  inputClassName={
                    showColorError && inpVal?.value === ""
                      ? "errBorder"
                      : isFromEditFlow && inpVal?.id
                        ? "variant_disabled_class"
                        : undefined
                  }
                  disabled={isFromEditFlow && inpVal?.id}
                />
              </div>
              <div>
                <div
                  className={`color-select cursorPointer ${isFromEditFlow && inpVal?.id
                    ? "variant_disabled_class"
                    : undefined
                    }`}
                  onClick={(e) => {
                    document
                      .getElementById(`variant-color-select-${ind}`)
                      ?.click?.();
                    if (!currentInputs?.[ind]?.label) {
                      const inpClone = [...currentInputs];
                      inpClone[ind].label = "#000000";
                      setCurrentInputs(inpClone);
                    }
                  }}
                  style={{
                    border:
                      showColorError && inpVal?.label === ""
                        ? "1px solid red"
                        : undefined,
                  }}
                >
                  <LineText className='fontSize14'>
                    {inpVal?.label || "Select color"}
                  </LineText>
                  <div
                    className='plus-circle'
                    style={{ background: inpVal?.label || "transparent" }}
                  >
                    {inpVal?.label ? (
                      <div className='empty-circle'></div>
                    ) : (
                      <PlusIcon height={"16px"} width={"16px"} />
                    )}
                  </div>
                  <AppColorInput
                    id={`variant-color-select-${ind}`}
                    value={inpVal?.label || "#000"}
                    onChange={(e) => {
                      const inpClone = [...currentInputs];
                      inpClone[ind].label = e.target.value;
                      setCurrentInputs(inpClone);
                    }}
                    disabled={isFromEditFlow && inpVal?.id}
                  />
                </div>
              </div>
              {currentInputs.length > 1 && ind + 1 !== currentInputs.length ? (
                <DeleteIcon
                  role='button'
                  onClick={() => {
                    const curr = [...currentInputs];
                    if (
                      1 !== currentInputs.length &&
                      ind + 1 !== currentInputs?.length
                    ) {
                      curr.splice(ind, 1);
                      setCurrentInputs(curr);
                    } else {
                      return;
                    }
                  }}
                />
              ) : <Box width={"20px"}></Box>}
            </div>
          );
        })}
      </div>
      <div
        className='d-flex my-4 user-select-none'
        style={{ columnGap: "1rem" }}
      >
        <UBButton
          id="variant_color_discard_btn"
          title='Discard'
          className='ub_ButtonMain discardBtn'
          titleStyle={{ color: "var(--darkGray)" }}
          onClick={setShowDiscard.bind(this, true)}
        />
        <UBButton
          id="variant_color_save_btn"
          title='Save'
          className='ub_ButtonMain saveAttrBtn ubSecondaryButton'
          onClick={handleSaveClrBtn}
        />
      </div>
      <ConfirmationModal
        id="discard_modal_variant_color"
        open={showDiscard}
        onClose={handleCancel}
        onConfirm={handleSaveDiscard}
        message={"You have unsaved changes"}
        title={"Are you sure you want to leave this screen and discard your changes?"}
        cancelText={"Cancel"}
        confirmButtonClassName="ubPrimaryButton"
        confirmText='YES'
      />
      
    </div>
  );
};
export default VariantColorComponent;
